import { getApiPublicBase } from './apiPublicBase';

/**
 * 将后端返回的上传资源路径（通常为 `/uploads/...`）转为浏览器可加载的 URL。
 * CRA 开发环境只代理 `/api`，需走 `/api/uploads/...`；配置了 `REACT_APP_API_BASE` 时拼绝对地址。
 */
export function resolveUploadAssetUrl(raw?: string | null): string | undefined {
  if (raw === undefined || raw === null || raw === '') return undefined;
  if (raw.startsWith('blob:') || raw.startsWith('data:')) return raw;
  if (/^https?:\/\//i.test(raw)) return raw;
  if (!raw.startsWith('/uploads/')) return raw;

  const apiPath = `/api${raw}`;
  const base = typeof window !== 'undefined' ? getApiPublicBase().replace(/\/$/, '') : '';
  if (base) {
    return `${base}${apiPath}`;
  }
  return apiPath;
}

/** 登录态展示用：与成员列表、个人中心一致，将 `/uploads/...` 转为可经 `/api` 代理加载的地址。 */
export function resolveUserAvatarSrc(raw?: string | null): string | undefined {
  if (!raw) return undefined;
  if (raw.startsWith('blob:')) return raw;
  return resolveUploadAssetUrl(raw) || raw;
}

/** 库存列表/弹窗：服务端路径走 `/api`，本地 data/blob 原样；无图时返回占位 */
export function resolveStockItemImageSrc(raw: string | undefined | null, fallback: string): string {
  if (raw === undefined || raw === null || String(raw).trim() === '') return fallback;
  return resolveUploadAssetUrl(raw) ?? String(raw);
}
